import { render, staticRenderFns } from "./ActList.vue?vue&type=template&id=516f7c3c&"
import script from "./ActList.vue?vue&type=script&lang=ts&"
export * from "./ActList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports